import styled from "styled-components";

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  
  thead td {
    font-weight: 500;
    color: #4B4B4B;
    background-color: #F8F9FF;
    padding-top: 2rem;
    padding-bottom: 2rem;
    border: 1px solid transparent;
    font-weight: bold;
  }
  
  tr {
    
  }
  
  td {
    font-size: 1.4rem;
    padding: 0.75rem 2rem;
    border-top: 1px solid rgba(192, 192, 192, 0.2);
    /* border-right: 1px solid rgba(192, 192, 192, 0.2); */
  }

  td:last-child {
    border-right: none;
  } 

  tr:hover {
    background-color: #fafafa;
    /* cursor: pointer; */
  }

  td.center {
    text-align: center;
  }

  td.break-word {
    word-break: break-all;
  }
`;